class WishlistManager {
    constructor(options = {}) {
        this.cookieName = options.cookieName || 'wishlist';
        this.buttonSelector = options.buttonSelector || '.add-to-wishlist';
        this.markedClass = options.markedClass || 'is-marked';
        this.backdropClass = options.backdropClass || 'page-wishlist-backdrop';
        this.countBubbleSelector = options.countBubbleSelector || '#wishlist-icon-bubble .wishlist-count-bubble';
        this.wishlistContainerSelector = options.wishlistContainerSelector || '#page-wishlist-inner-items';

        this.storeDomain = options.storeDomain || 'f7e178-5d.myshopify.com'; // Replace
        this.accessToken = options.accessToken || 'f9ff839e1c24988d70de6f0e2df92cb0'; // Replace

        this.init();
    }

    init() {
        this.syncUI();
        this.bindEvents();
        this.refreshWishlistView(); // Populate wishlist view
    }

    getWishlist() {
        const cookieValue = document.cookie
            .split('; ')
            .find(row => row.startsWith(`${this.cookieName}=`));
        if (!cookieValue) return [];

        try {
            return JSON.parse(decodeURIComponent(cookieValue.split('=')[1])) || [];
        } catch (e) {
            return [];
        }
    }

    setWishlist(ids) {
        const uniqueIds = [...new Set(ids)];

        const expires = new Date();
        expires.setTime(expires.getTime() + (365 * 24 * 60 * 60 * 1000)); // 1 year

        document.cookie = `${this.cookieName}=${encodeURIComponent(JSON.stringify(uniqueIds))}; path=/; expires=${expires.toUTCString()}; SameSite=Lax`;
    }

    toggleProduct(productId) {
        const wishlist = this.getWishlist();
        const index = wishlist.indexOf(productId);

        if (index === -1) {
            wishlist.push(productId);
        } else {
            wishlist.splice(index, 1);
        }

        this.setWishlist(wishlist);
        this.syncUI();
        this.refreshWishlistView(); // Re-render list
    }

    syncUI() {
        const wishlist = this.getWishlist();
        const buttons = document.querySelectorAll(this.buttonSelector);

        buttons.forEach(button => {
            const id = button.getAttribute('data-product-id');
            if (!id) return;

            if (wishlist.includes(id)) {
                button.classList.add(this.markedClass);
            } else {
                button.classList.remove(this.markedClass);
            }
        });

        this.updateCountBubble(wishlist.length);
    }

    updateCountBubble(count) {
        const bubble = document.querySelector(this.countBubbleSelector);
        if (bubble) {
            bubble.textContent = count;
        }
    }

    bindEvents() {
        document.addEventListener('click', event => {
            const toggleBtn = event.target.closest(this.buttonSelector);
            if (toggleBtn) {
                const productId = toggleBtn.getAttribute('data-product-id');
                if (productId) {
                    this.toggleProduct(productId);
                }
            }

            const removeBtn = event.target.closest('.remove-from-wishlist');
            if (removeBtn) {
                const productId = removeBtn.getAttribute('data-product-id');
                if (productId) {
                    this.toggleProduct(productId);
                }
            }

            // Your wishlist panel open/close handlers:
            if (event.target.closest('.header__icon--wishlist')) {
                document.querySelector('.page-wishlist')?.classList.add('is-open');
                document.querySelector('.page-wishlist-backdrop')?.classList.add('is-open');
            }

            if (event.target.closest('.page-wishlist-close')) {
                document.querySelector('.page-wishlist')?.classList.remove('is-open');
                document.querySelector('.page-wishlist-backdrop')?.classList.remove('is-open');
            }

            if ( event.target.closest('.page-wishlist-backdrop') ) {
                document.querySelector('.page-wishlist')?.classList.remove('is-open');
                document.querySelector('.page-wishlist-backdrop')?.classList.remove('is-open');
            }
        });
    }

    async fetchProductsByIds(ids) {
        if (!ids.length) return [];

        const globalIds = ids.map(id => `gid://shopify/Product/${id}`);
        const query = `
      query getProducts($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on Product {
            id
            title
            handle
            tags
            images(first: 1) {
              edges {
                node {
                  url
                  altText
                }
              }
            }
            priceRange {
              minVariantPrice {
                amount
                currencyCode
              }
            }
          }
        }
      }
    `;

        const response = await fetch(`https://${this.storeDomain}/api/2024-04/graphql.json`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': this.accessToken
            },
            body: JSON.stringify({ query, variables: { ids: globalIds } })
        });

        const json = await response.json();
        return json.data?.nodes?.filter(Boolean) || [];
    }

    async refreshWishlistView() {
        const container = document.querySelector(this.wishlistContainerSelector);
        if (!container) return;

        const ids = this.getWishlist();
        if (ids.length === 0) {
            container.innerHTML = '<p>Deine Wunschliste ist leer.</p>';
            return;
        }

        const products = await this.fetchProductsByIds(ids);

        container.innerHTML = products.map(product => {
            const image = product.images.edges[0]?.node;
            const price = product.priceRange.minVariantPrice;
            const productId = product.id.split('/').pop();


            const tagsHTML = product.tags && product.tags.length > 0
                ? `<div class="product-card-tags display-flex flex-row gap-2 padding-top-0 padding-bottom-3">
            ${product.tags.map(tag => `<div class="product-card-tag">${tag}</div>`).join('')}
           </div>`
                : '';

            return `
        <div class="wishlist-item align-items-start" data-product-id="${productId}">
          <img src="${image?.url || ''}" alt="${image?.altText || product.title}" />
          <div class="wishlist-item-info display-flex flex-column justify-content-between row-gap-2">
            <div class="wishlist-item-info-top">
                <h4> <a href="/products/${product.handle}">${product.title}</a></h4>
                 ${tagsHTML}
                <div class="wishlist-item-info-price">${price.amount} ${price.currencyCode}</div>
            </div>
            <div class="wishlist-item-info-bottom display-flex flex-row justify-content-between">
                <a href="/products/${product.handle}">Zum Produkt</a>
                <button class="remove-from-wishlist" data-product-id="${productId}">Entfernen</button>
            </div>
          </div>
        </div>
      `;
        }).join('');
    }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    new WishlistManager({
        storeDomain: 'f7e178-5d.myshopify.com', // 🔁 Replace with your store
        accessToken: 'f9ff839e1c24988d70de6f0e2df92cb0' // 🔁 Replace with your token
    });
});
